import { render } from "./TopAnalyticsTemplate.vue?vue&type=template&id=0147fb5f"
import script from "./TopAnalyticsTemplate.vue?vue&type=script&lang=js"
export * from "./TopAnalyticsTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script